import React, { Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { updateProject } from '../store/actions'
import { useHistory } from 'react-router-dom'
import { getCurrentProject } from '../store/selectors'
import { Form, Field } from '@progress/kendo-react-form'
import {
    Page,
    BackButton,
    FieldDescription,
    Row,
    Column,
    Section,
    InputField,
    Invisible,
    PrintButtonContainer,
    PrintButton,
    PrintFormHeader,
    ResizableInputField
} from '../components/printForm'
import PrintFormDateField from '../components/printForm/PrintFormDateField'

export default () => {
    const history = useHistory()
    const project = useSelector(getCurrentProject)
    const dispatch = useDispatch()

    const responsible = `${project.inChargeDepartment} - ${project.inChargeName}, Tel.`

    const handleFormSubmit = (data) => {
        dispatch(updateProject({ project: data }))
        window.print()
    }

    return <div>
        <BackButton onClick={() => history.goBack()}>Zurück</BackButton>
        <Page>

            <PrintFormHeader title="Bestellung Drucksachen" responsible={responsible} />

            <Form initialValues={project} onSubmit={handleFormSubmit} render={(formRenderProps) => (
                <Fragment>
                    <Row>
                        <Section width={'100%'}>
                            <FieldDescription>Beschreibung</FieldDescription>
                            <Field rows="1" name="title" component={InputField}/>
                        </Section>
                    </Row>

                    <Row>
                        <Section width={'49%'}>
                            <FieldDescription>Materialnummer</FieldDescription>
                            <Field rows="1" name="mediaNumber" component={InputField}/>
                        </Section>
                        <Section width={'49%'}>
                            <FieldDescription>Sprache</FieldDescription>
                            <InputField rows="1" value={project.projectLanguage.title} readOnly/>
                        </Section>
                    </Row>

                    <Row>
                        <Section width={'49%'}>
                            <FieldDescription>Auftrag geht an</FieldDescription>
                            <Field rows="1" name="printOrderTo" component={InputField}/>
                        </Section>
                        <Section width={'17%'}>
                            <FieldDescription>Kostenstelle</FieldDescription>
                            <Field rows="1" name="customerCostCenter" component={InputField}/>
                        </Section>
                        <Section width={'30%'}>
                            <FieldDescription>WA-Nummer</FieldDescription>
                            <Field rows="1" name="customerWANumber" component={InputField}/>
                        </Section>
                    </Row>

                    <Row narrow>
                        <Section width={'15%'}>
                            <FieldDescription>Umschlag</FieldDescription>
                            <InputField rows="1" defaultValue="Umschlag"/>
                        </Section>
                        <Section width={'7%'}>
                            <FieldDescription>Seiten</FieldDescription>
                            <Field rows="1" name="paperEnvelopePages" component={InputField}/>
                        </Section>
                        <Section width={'74%'}>
                            <FieldDescription>Papier</FieldDescription>
                            <Field rows="1" name="paperEnvelopeType" component={InputField}/>
                        </Section>
                    </Row>

                    <Row>
                        <Section width={'15%'}>
                            <InputField rows="1" defaultValue="Inhalt"/>
                        </Section>
                        <Section width={'7%'}>
                            <Field rows="1" name="paperContentPages" component={InputField}/>
                        </Section>
                        <Section width={'74%'}>
                            <Field rows="1" name="paperContentType" component={InputField}/>
                        </Section>
                    </Row>

                    <Row>
                        <Section width={'49%'}>
                            <FieldDescription>Format gefalzt</FieldDescription>
                            <Field rows="1" name="mediaFormatFolded" component={InputField}/>
                        </Section>
                        <Section width={'49%'}>
                            <FieldDescription>Format offen</FieldDescription>
                            <Field rows="1" name="mediaFormatUnFolded" component={InputField}/>
                        </Section>
                    </Row>

                    <Row>
                        <Section width={'49%'}>
                            <FieldDescription>Farbe/Druck</FieldDescription>
                            <Field rows="5" name="mediaColor" component={InputField}/>
                        </Section>

                        <Column>
                            <Section width={'100%'}>
                                <FieldDescription>Auflagenhöhe (Exemplare, Staffelung)</FieldDescription>
                                <Field rows="1" name="mediaAmountRequested" component={InputField}/>
                            </Section>
                            <Section width={'100%'} style={{ marginTop: '15px' }}>
                                <FieldDescription>Gestellt werden</FieldDescription>
                                <Field rows="1" name="mediaPrePrint" component={InputField}/>
                            </Section>
                        </Column>
                    </Row>

                    <Row>
                        <Section width={'100%'}>
                            <FieldDescription>Verarbeitung</FieldDescription>
                            <Field rows="3" name="mediaProcessing" component={ResizableInputField}/>
                        </Section>
                    </Row>

                    <Row>
                        <Section width={'49%'}>
                            <FieldDescription>Liefertermin für Drucksache</FieldDescription>
                            <PrintFormDateField name="printOrderNegotiatedDelivery" form={formRenderProps}/>
                        </Section>
                        <Section width={'8%'}>
                            <FieldDescription>Abladestelle</FieldDescription>
                            <Field rows="1" name="customerDepartment" component={InputField}/>
                        </Section>
                        <Section width={'39%'}>
                            <FieldDescription/>
                            <Field rows="1" name="customerName" component={InputField}/>
                        </Section>
                    </Row>

                    <Row>
                        <Section width={'100%'}>
                            <FieldDescription>Info für SE</FieldDescription>
                            <InputField rows="1"/>
                        </Section>
                    </Row>

                    <Row>
                        <Section width={'100%'}>
                            <FieldDescription>Besonderheiten</FieldDescription>
                            <Field rows="5" name="remarks" component={ResizableInputField}/>
                        </Section>
                    </Row>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        marginRight: '-12px',
                        marginTop: '40px'
                    }}>
                        <Section width={'40%'} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                            <div style={{ width: '250px', textAlign: 'center' }}>Gesamtpreis
                            </div>
                            <InputField rows="1"/>
                        </Section>
                        <Section width={'40%'} style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ width: '250px', textAlign: 'center' }}>Preis 0/00
                            </div>
                            <InputField rows="1"/>
                        </Section>
                    </div>

                    <Field name="dummyField" component={Invisible}/>

                    <PrintButtonContainer>
                        <PrintButton onClick={() => {
                            formRenderProps.onChange('dummyField', { value: '' })
                            formRenderProps.onSubmit()
                        }}>Drucken</PrintButton>
                    </PrintButtonContainer>
                </Fragment>
            )}/>

        </Page>
    </div>
}



// WEBPACK FOOTER //
// ./src/pages/PrintOrder.js